export const SEM_CLASSIFICACAO = { subnicho: 'Outros', assunto: 'Outros assuntos' };

// Casa o título (ou qualquer texto) do roteiro contra a taxonomia do projeto
// (lista de { subnicho, assunto, palavras_chave }) e devolve o par com mais
// palavras-chave batendo. O sistema decide — ninguém digita subnicho/assunto na mão.
export function classificarConteudo(texto, taxonomia) {
  if (!texto || !taxonomia?.length) return SEM_CLASSIFICACAO;
  const alvo = texto.toLowerCase();
  let melhor = null;
  let melhorScore = 0;
  for (const t of taxonomia) {
    const score = (t.palavras_chave || []).filter(p => alvo.includes(p.toLowerCase())).length;
    if (score > melhorScore) { melhor = t; melhorScore = score; }
  }
  return melhor ? { subnicho: melhor.subnicho, assunto: melhor.assunto } : SEM_CLASSIFICACAO;
}

// Taxonomia inicial sugerida pro nicho de advocacia/dívidas (Gabriel Melo) —
// só um ponto de partida, cada projeto pode ter a sua própria.
export const TAXONOMIA_PADRAO_ADVOCACIA = [
  { subnicho: 'Revisional', assunto: 'Revisional de financiamento de veículo', palavras_chave: ['financiamento de veículo', 'financiamento de carro', 'revisional de financiamento'] },
  { subnicho: 'Revisional', assunto: 'Revisional de empréstimo consignado', palavras_chave: ['consignado', 'empréstimo consignado'] },
  { subnicho: 'Revisional', assunto: 'Revisão de juros abusivos', palavras_chave: ['juros abusivos', 'juros altos', 'juro abusivo'] },
  { subnicho: 'Busca e Apreensão', assunto: 'Defesa de ação de busca e apreensão', palavras_chave: ['busca e apreensão', 'apreensão do carro', 'apreensão do veículo'] },
  { subnicho: 'Portabilidade', assunto: 'Portabilidade de dívida', palavras_chave: ['portabilidade'] },
  { subnicho: 'Dívidas', assunto: 'Dívidas de veículo de alto valor', palavras_chave: ['veículo de alto valor', 'carro de alto valor', 'caminhão'] },
  { subnicho: 'Dívidas', assunto: 'Superendividamento', palavras_chave: ['superendividado', 'superendividamento', 'endividado'] },
];
